import type { SyteConfig } from '#types/config/components/syte'
import type { RecursivePartial } from '#types/utils'

export default {
  accountId: '10631',
  accountSignature: '65c5c89f8b57c4181dcd8cd4'
} satisfies RecursivePartial<SyteConfig>
